import React, { useState, useEffect } from "react";
import { Segment } from "semantic-ui-react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/Sidebar"; 
import ConfigurationPage from "./Configuration"; 
import "../../styles/Configuration.css"; 

const Configuration = () => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const [toggleBtn, setToggleBtn] = useState(window.innerWidth >= 1140);

  const handleCloseButtonClick = () => {
    setToggleBtn(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1140 && isAuthenticated) {
        setToggleBtn(true);
      } else {
        setToggleBtn(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isAuthenticated]);

  return (
    <div className="configuration-page">
      {isAuthenticated && toggleBtn && (
        <Sidebar toggleBtn={toggleBtn} onCloseButtonClick={handleCloseButtonClick} />
      )}
      <div className={`configuration-container ${isAuthenticated ? (toggleBtn ? '' : 'full-width') : 'not-authenticated'}`}>
        <Segment className="configuration-segment">
          <ConfigurationPage />
          
        </Segment>
      </div>
    </div>
  );
};

export default Configuration;
